import { createVuetify } from 'vuetify';
import 'vuetify/styles';
import icons from '../config/vuetify/icons';
import { aliases, mdi as mdiSvg } from 'vuetify/iconsets/mdi-svg';
import { defineNuxtPlugin } from 'nuxt/app';
import { useAppStore } from '../stores/appStore.ts';

export default defineNuxtPlugin((nuxtApp) => {
    const store = useAppStore();
    const { appThemeCookie, systemThemeCookie, setSystemTheme } = useThemeCookie();

    function getMatchMedia() {
        if (!import.meta.client) return null;
        return window.matchMedia('(prefers-color-scheme: dark)');
    }

    const systemTheme = ref(systemThemeCookie.value);

    if (import.meta.client) {
        let media: MediaQueryList = getMatchMedia()!;
        systemTheme.value = media.matches ? 'dark' : 'light';
        setSystemTheme(systemTheme.value);

        media.addEventListener('change', () => {
            systemTheme.value = media.matches ? 'dark' : 'light';
            setSystemTheme(systemTheme.value);
        });
    }

    const resolvedTheme = computed(() => {
        return appThemeCookie.value === 'system' ? systemTheme.value : appThemeCookie.value;
    });

    const vuetify = createVuetify({
        ssr: true,
        theme: {
            defaultTheme: resolvedTheme.value,
            themes: {
                dark: {
                    dark: true,
                    colors: {
                        primary: '#FF4800',
                        secondary: '#F05113',
                        drawer: '#2D2F31',
                        background: '#121212',
                        surface: '#1F1F1F',
                        error: '#BA1A1A',
                        info: '#EE730A',
                        success: '#4CAF50',
                        warning: '#FB8C00'
                    }
                },
                light: {
                    dark: false,
                    colors: {
                        primary: '#FF4800',
                        secondary: '#FF4800',
                        drawer: '#F3F6FC',
                        background: '#F4F5FA',
                        surface: '#FFFFFF',
                        error: '#BA1A1A',
                        info: '#EE730A',
                        success: '#4CAF50',
                        warning: '#FB8C00'
                    }
                }
            }
        },
        icons: {
            defaultSet: 'mdiSvg',
            aliases: {
                ...icons,
                ...aliases,
            },
            sets: {
                mdiSvg,
            }
        }
    });

    nuxtApp.vueApp.use(vuetify);
});